// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3NS6u","label":"Section_label__e1DWr","contentWrap":"Section_contentWrap__1DNkR","footer":"Section_footer__2utnu","footerInner":"Section_footerInner__1Gqa5"};